export default {
      id: "icon-currency-usage",
      viewBox: "0 0 118 118",
      url: __webpack_public_path__ + "icons.svg#icon-currency",
      toString: function () {
        return this.url;
      }
    }